module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "voting-widget"
  }, [_c('a', {
    class: [{
      'logged-voted': _vm.loggedVote === 1
    }, 'upvote', 'vote-button', {
      disabled: !_vm.isLoggedIn
    }],
    on: {
      "click": function($event) {
        _vm.vote('up')
      }
    }
  }, [_c('i', {
    class: ['fa', 'fa-arrow-up']
  })]), _vm._v(" "), _c('a', {
    class: [{
      'logged-voted': _vm.loggedVote === -1
    }, 'downvote', 'vote-button', {
      disabled: !_vm.isLoggedIn
    }],
    on: {
      "click": function($event) {
        _vm.vote('down')
      }
    }
  }, [_c('i', {
    class: ['fa', 'fa-arrow-down']
  })]), _vm._v(" "), _c('span', {
    staticClass: "points",
    on: {
      "mouseenter": function($event) {
        _vm.showTooltip = true
      },
      "click": function($event) {
        _vm.showTooltip = true
      }
    }
  }, [_vm._v(_vm._s(_vm.points) + " points")]), _vm._v(" "), (_vm.showTooltip) ? _c('div', {
    staticClass: "tooltip",
    on: {
      "mouseleave": function($event) {
        _vm.showTooltip = false
      }
    }
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm.upVoters.length === 0) ? [_vm._v("\n                No Upvotes Yet\n            ")] : _vm._e(), _vm._v(" "), (_vm.upVoters.length > 0) ? [_vm._v("\n                Upvoted by:\n                "), _vm._l((_vm.upVoters), function(upVoter) {
    return _c('span', [_c('router-link', {
      attrs: {
        "to": ("/Developer/" + (upVoter.stringUrl))
      }
    }, [_vm._v(_vm._s(upVoter.alias))])], 1)
  })] : _vm._e()], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b744631a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Common/VotingWidget/VotingWidget.vue
// module id = 911
// module chunks = 2